export default {"src":"/_next/static/media/desktop-default.b132b66f.svg","height":100,"width":284,"blurWidth":0,"blurHeight":0};